/**
 * Acces au stockage local qui ne peut pas faire tomber la page.
 *
 * localStorage leve une exception dans plusieurs cas ordinaires : quota plein,
 * navigation privee, stockage bloque par le navigateur. Or ces cles ne portent
 * que des preferences d'affichage (le modele IA choisi, une largeur de volet,
 * un filtre) : en perdre une est sans consequence, remplacer l'ecran par la
 * page d'erreur ne l'est pas.
 *
 * Le danger est reel : une ecriture dans un `useEffect` ou une lecture dans un
 * initialiseur de `useState` se produit pendant le cycle de rendu, donc React
 * remonte l'exception jusqu'a la limite d'erreur et remplace la page entiere.
 * C'est ce qui rendait l'editeur d'Article AI impossible a ouvrir : le quota
 * sature faisait echouer l'ecriture de `articleAI_chatModel`, et l'ecran
 * "Une erreur est survenue" prenait la place de l'editeur a chaque tentative.
 *
 * Toute preference stockee cote navigateur doit passer par ici.
 *
 * Les trois fonctions de session repondent au meme besoin sur
 * `sessionStorage`, qui ne survit pas a la fermeture de l'onglet : c'est la ou
 * vivent les donnees qu'on veut reprendre d'un ecran a l'autre sans les laisser
 * sur la machine, comme la signature des formulaires de /outils.
 */

export function readLocal(key, fallback = null) {
    if (typeof window === "undefined") return fallback;
    try {
        const value = window.localStorage.getItem(key);
        return value === null ? fallback : value;
    } catch (e) {
        return fallback;
    }
}

/**
 * @returns {boolean} true si la valeur a bien ete ecrite. Utile quand l'appelant
 * veut prevenir l'utilisateur ; la plupart des preferences peuvent l'ignorer.
 */
export function writeLocal(key, value) {
    if (typeof window === "undefined") return false;
    try {
        window.localStorage.setItem(key, value);
        return true;
    } catch (e) {
        return false;
    }
}

export function removeLocal(key) {
    if (typeof window === "undefined") return false;
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
}

export function readSession(key, fallback = null) {
    if (typeof window === "undefined") return fallback;
    try {
        const value = window.sessionStorage.getItem(key);
        return value === null ? fallback : value;
    } catch (e) {
        return fallback;
    }
}

/** @returns {boolean} true si la valeur a bien ete ecrite. */
export function writeSession(key, value) {
    if (typeof window === "undefined") return false;
    try {
        window.sessionStorage.setItem(key, value);
        return true;
    } catch (e) {
        return false;
    }
}

export function removeSession(key) {
    if (typeof window === "undefined") return false;
    try {
        window.sessionStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
}
